<template>
  <v-snackbar 
    v-model="default_snackbar"
    :timeout="-1"
    top
    centered
    :color="color"
  >
    {{ text }}

    <template v-slot:action="{ attrs }">
      <v-btn
        class="white--text"
        text
        v-bind="attrs"
        @click="close"
      >
        {{ $t('fechar') }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import EventBus from "../../plugins/event-bus";

export default {
  name: "AppToast",
  props: {
    snackbar: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,  
      default: ""
    },
    color: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      default_snackbar: false,
      timeout: 5000
    }
  },
  watch: {
    snackbar: {
      handler() {
        clearTimeout(this._timerId);
        if (this.snackbar) {
          this._timerId = setTimeout(this.close, this.timeout);
        }
        this.default_snackbar = this.snackbar;
      },
      deep: true
    }
  },
  methods: {
    close() {
      EventBus.$emit("criarAlerta", { snackbar: false, text: "", color: this.color });
    }
  }
};
</script>